<template>
  <div class="zzd">
    <div class="IDdy">
      <ul class="xx">
        <li>患者姓名：{{zzdata.CustomerName}}</li>
        <li>性别：{{zzdata.CustomerGender}}</li>
        <li>年龄：{{zzdata.CustomerAge}}</li>
        <li>联系电话：{{zzdata.CustomerTel}}</li>
      </ul>

      <h3>转出资料</h3>
      <div class="boxp">
        <p class="pd-r15">转出单位：{{zzdata.CreateCompanyName}}</p>
        <p class="pd-r15">地址：{{zzdata.CreateShop.ShopAddress}}</p>
        <p>电话：{{zzdata.CreateShop.ShopTel}}</p>
      </div>
      <div class="boxp">
        <p>就诊时间：</p>
        <p>{{zzdata.CheckTime}}</p>
        <p style="margin-left: 20px;">转出时间：</p>
        <p>{{zzdata.TaskStartTime}}</p>
      </div>
      <div class="boxp">
        <p>诊断结论：</p>
        <div style="text-align: left;width: 590px;">
          {{zzdata.CheckResult_Diagnosis_Text}}
        </div>
      </div>
      <div class="boxp">
        <p>备注：</p>
        <p>{{zzdata.ReferralRemark}}</p>
      </div>

      <h3>转入资料</h3>
      <div class="boxp">
        <p>转入单位：</p>
        <p>{{zzdata.ReferralCC.CC_Name}}</p>
        <p style="margin-left: 20px;">地址信息：{{zzdata.ReferralCC.CC_Address}}</p>
      </div>
      <div class="boxp">
        <p>联系人：{{zzdata.ReferralCC.CC_Person}}</p>
        <p style="padding-left: 20px;">联系电话：{{zzdata.ReferralCC.CC_Tel}}</p>
      </div>
      <div class="boxp">
        <p>预约时间：</p>
        <p>{{zzdata.OppointmentTime}}</p>
        <p style="margin-left: 20px;">转入科室：</p>
        <p>{{zzdata.ReferralDeptName}}</p>
      </div>

      <div class="boxp">
        <p>转入单位接诊注意事项：</p>
        <p>{{zzdata.TaskContent}}</p>
      </div>
    </div>

    <el-button type="primary" style="margin-top: 20px;" @click="dy">打印</el-button>
  </div>
</template>

<script>
import {getDgzz, getExpertClinic} from "./api";
import { VuePrintNext } from 'vue-print-next';
export default {
  name: "zzd",
  data() {
    return {
      zzdata: {ReferralCC: {}, CreateShop: {}},
      zdod: '',
      zdos: ''
    }
  },
  props: {
    ids: {
      default: ''
    }
  },
  created() {
    let log = this.$loading({
      text: '加载中...'
    })
    getDgzz(this.ids)
    .then(res => {
      log.close()
      if (res.Result) {
        this.zzdata = res.Result
      }
    })
  },
  methods: {
    dy() {
      new VuePrintNext({el: '.IDdy'})
    }
  }
}
</script>

<style scoped lang="scss">
.zzd {color: #0a0a0a;font-size: 14px;}
.IDdy {font-size: 14px;}
.xx {
  display: flex;
  justify-content: center;
  li {padding: 0 15px;}
}
h3 {
  font-size: 15px;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 5px;
}
.boxp {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.pd-r15 {padding-right: 20px;}
</style>
